import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavService } from '../../service/nav.service';
import { AuthenticationService } from '../../../components/services/auth/authentication.service';
import { SessionSetupService } from '../../service/session-setup.service';
import { trigger, transition, useAnimation } from '@angular/animations';
import { bounce, zoomOut, zoomIn, fadeIn, bounceIn } from 'ng-animate';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
  animations: [
    trigger('animateRoute', [transition('* => *', useAnimation(fadeIn, {
      // Set the duration to 5seconds and delay to 2 seconds
      //params: { timing: 3}
    }))])
  ]
})
export class ContentLayoutComponent implements OnInit, OnDestroy {

  public right_side_bar: boolean;
  public layoutType: string = 'RTL';
  public layoutClass: boolean = false;

  constructor(
    public navServices: NavService,
    public authService: AuthenticationService,
    private sessionSetup: SessionSetupService
  ) {}

  /** true si el perfil del usuario habilita el menú lateral (por defecto true) */
  get showSystemMenu(): boolean {
    return this.authService.currentUserValue?.show_system_menu !== false;
  }

  public getRouterOutletState(outlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  public rightSidebar($event) {
    this.right_side_bar = $event
  }

  public clickRtl(val) {
    if (val === 'RTL') {
      document.body.classList.add('rtl');
      this.layoutClass = true;
      this.layoutType = 'LTR';
    } else {
      document.body.classList.remove('rtl');
      this.layoutClass = false;
      this.layoutType = 'RTL';
    }
  }

  ngOnInit() {
    document.body.classList.add('portal-admin');
    this.sessionSetup.hydrateTheme().catch(() => {});
  }

  ngOnDestroy() {
    document.body.classList.remove('portal-admin');
  }

}
